import React, { useState } from 'react'
import profile from '../../images/login-profile.png'
import { Button, Card, Form, Input } from 'reactstrap'
import ForgotPasswordComponent from './ForgotPasswordComponent'
import { AiOutlineMail } from 'react-icons/ai'
import NotAuthCMS from '../../components/not-auth/NotAuthCMS'
import { useTranslation } from 'react-i18next'

const ForgotPassword = () => {
    const [formData, setFormData] = useState({ mail: "" })
    const handleForgotPassword = ForgotPasswordComponent();
    const { t } = useTranslation();

    const handleSubmit = (e) => {
        e.preventDefault()
        handleForgotPassword(formData);
    }

    return (
        <NotAuthCMS>
            <div className='forgot-password-page'>
                <Card className='login-card'>
                    <div className='w-100 d-flex justify-content-center'><img src={profile} alt='' /></div>
                    <div className='w-100 d-flex justify-content-center'><strong>{t("forgot_password")}</strong></div>
                    <div className='w-100 d-flex justify-content-center'><span>{t("forgot_password_text")}</span></div>
                    <hr />
                    <Form onSubmit={handleSubmit}>
                        <div>
                            <label htmlFor="email">{t("eposta")}</label>
                            <div className='form-element'>
                                <AiOutlineMail size={18} />
                                <Input
                                    id="email"
                                    name="email"
                                    type='text'
                                    placeholder='info@liberyus.com'
                                    value={formData.mail}
                                    onChange={e => setFormData({ ...formData, mail: e.target.value })}
                                    required
                                />
                            </div>
                        </div>
                        <Button type="submit" color='primary' className='w-100 mt-3'>{t("send")}</Button>
                    </Form>
                </Card>
            </div>
        </NotAuthCMS>
    )
}

export default ForgotPassword
